import SVRedirect from '@apps/www/src/www/containers/SVRedirect';
import appendQueryParamsToURL from '@pkgs/shared/helpers/appendQueryParamsToURL';
import parseQueryParam from '@pkgs/shared/helpers/parseQueryParam';
import { useRouter } from 'next/router';

const SVJoinPage = () => {
	const router = useRouter();
	const next = parseQueryParam(router.query.next);

	return (
		<SVRedirect to={appendQueryParamsToURL('/login/', next ? { next } : {})} replace={true} />
	);
};

SVJoinPage.withNavHidden = true;

export default SVJoinPage;
